(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arsk-ask1"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__arskRedirectBound) return;
  window.__arskRedirectBound = true;
  function go() {
    var el = document.querySelector('[data-arsk-redirect]');
    if (!el) return;
    var url = el.getAttribute('data-arsk-redirect');
    if (url) window.location.replace(url);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', go);
  } else {
    go();
  }
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arsk-contact-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__arskRedirectBound) return;
  window.__arskRedirectBound = true;
  function go() {
    var el = document.querySelector('[data-arsk-redirect]');
    if (!el) return;
    var url = el.getAttribute('data-arsk-redirect');
    if (url) window.location.replace(url);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', go);
  } else {
    go();
  }
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arsk-hero2"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.h4Ready === '1') return;
    root.dataset.h4Ready = '1';
    var track = root.querySelector('[data-h4-track]');
    var dots = root.querySelectorAll('[data-h4-dot]');
    var prev = root.querySelector('[data-h4-prev]');
    var next = root.querySelector('[data-h4-next]');
    var count = track ? track.children.length : 0;
    if (!track || count < 2) return;
    var i = 0;

    function go(n) {
      i = (n + count) % count;
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      for (var d = 0; d < dots.length; d++) {
        dots[d].setAttribute('aria-current', d === i ? 'true' : 'false');
      }
    }
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    for (var d = 0; d < dots.length; d++) {
      (function (n) {
        dots[n].addEventListener('click', function () { go(n); });
      })(d);
    }

    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 50) go(dx < 0 ? i + 1 : i - 1);
      x0 = null;
    }, { passive: true });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') go(i + 1);
      if (e.key === 'ArrowLeft') go(i - 1);
    });
  }
  function run() {
    var els = document.querySelectorAll('[data-arsk-h4]');
    for (var k = 0; k < els.length; k++) init(els[k]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }
  document.addEventListener('shopify:section:load', run);
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arsk-megamenu"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(panel) {
    if (panel.dataset.arskReady === '1') return true;
    var label = (panel.dataset.triggerText || '').trim().toLowerCase();
    var href = (panel.dataset.triggerHref || '').trim();
    var links = document.querySelectorAll('header a, [id*="header"] a, [class*="header"] a, nav a');
    var trigger = null;
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (panel.contains(a)) continue;
      var txt = (a.textContent || '').trim().toLowerCase();
      var hit = label && txt === label;
      if (!hit && href) hit = (a.getAttribute('href') || '').indexOf(href) !== -1;
      if (hit) { trigger = a; break; }
    }
    if (!trigger) return false;

    var header = trigger;
    while (header && header !== document.body) {
      if (header.tagName === 'HEADER' || (header.id || '').indexOf('header') !== -1) break;
      header = header.parentElement;
    }
    if (!header || header === document.body) header = trigger.closest('nav') || trigger;

    if (panel.parentElement !== document.body) document.body.appendChild(panel);
    panel.dataset.arskReady = '1';

    var timer = null;
    function place() {
      var r = header.getBoundingClientRect();
      panel.style.top = Math.max(0, r.bottom) + 'px';
    }
    function open() { clearTimeout(timer); place(); panel.classList.add('is-open'); }
    function close() { timer = setTimeout(function () { panel.classList.remove('is-open'); }, 160); }

    trigger.addEventListener('mouseenter', open);
    trigger.addEventListener('mouseleave', close);
    trigger.addEventListener('focus', open);
    panel.addEventListener('mouseenter', function () { clearTimeout(timer); });
    panel.addEventListener('mouseleave', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') panel.classList.remove('is-open');
    });
    window.addEventListener('scroll', function () {
      if (panel.classList.contains('is-open')) place();
    }, { passive: true });
    window.addEventListener('resize', place);
    return true;
  }

  function run() {
    var panels = document.querySelectorAll('[data-arsk-mega]');
    var allReady = panels.length > 0;
    for (var i = 0; i < panels.length; i++) {
      if (!setup(panels[i])) allReady = false;
    }
    return allReady;
  }

  function boot() {
    if (run()) return;
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (run() || tries > 20) clearInterval(iv);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function () { setTimeout(run, 60); });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
